module.exports = __webpack_public_path__ + "img/userB11.9cef4640.jpg";